export const PROVIDE_LABEL_OPTIONS = {
  PRINT: 'PRINT',
  EMAIL: 'EMAIL',
  LABELLESS: 'UPS_LABELLESS',
  MAIL: 'MAIL',
  PICKUP: 'UPS_PICKUP',
  ANY_CARRIER: 'ANY_CARRIER',
  UPS_PACKAGELESS: 'UPS_PACKAGELESS',
  WFM_PACKAGELESS: 'WFM_PACKAGELESS'
};

export const GET_ORDER_ID_ATTEMPTS = {
  INITIAL_ATTEMPTS: 0,
  MAX_ATTEMPTS: 10
};
